export default class PrinterPalletRequest
{
  palletId:number = 0;
  constructor(_palletId:number)
  {
    this.palletId = _palletId;
  }

}
